import React, { useEffect, useState } from 'react'
import { reaction, toJS, comparer } from 'mobx'
import { observer } from 'mobx-react'
import WidgetContainer from '../../WidgetContainer'
import Panel from '../../../../UniformComponents/Panel'

const WidgetPreview = ({ newWidget, dashStore }) => {
    const [chartData, setChartData] = useState()
    const [loadingData, setLoadingData] = useState(false)
    useEffect(() => {
        const { getChartData } = dashStore
        const dispose = reaction(
            () => newWidget.chartRefreshFields,
            async () => {
                const widget = newWidget.newWidgetToWidget()
                if (!widget.kpiType || !widget.chartType) return
                setLoadingData(true)
                const data = await getChartData([widget])
                newWidget.data = data
                setChartData(data)
                setLoadingData(false)
            },
            {
                equals: comparer.structural,
            },
        )
        return dispose
    }, [newWidget])

    useEffect(() => {
        const { getChartData } = dashStore
        const dispose = reaction(
            () => newWidget.chartType,
            async (newVal, oldVal) => {
                if (newVal && !oldVal) {
                    const data = await getChartData([newWidget.newWidgetToWidget()])
                    newWidget.data = data
                    setChartData(data)
                }
            },
        )
        return dispose
    }, [newWidget])
    const changeTitle = () => console.log('THTEST value')
    const { questionId, formId } = newWidget.newWidgetToWidget()
    const containerKey = `${questionId}-${formId}`
    return (
        <Panel style={{ flex: '1' }}>
            <div style={{
                display: 'flex', flexDirection: 'column', height: '100%', gap: '8px',
            }}
            >
                <div className="title">
                    <h3>Widget Preview</h3>
                    <div style={{ fontSize: '13px', marginTop: '4px' }}>
                        Preview updates automatically as you modify options
                    </div>
                </div>
                <div style={{
                    height: '100%', width: '100%', overflow: 'hidden', flex: '1',
                }}
                >
                    <div className="previewPane" style={{ height: '100%', width: '100%' }}>
                        {chartData && !loadingData
                            ? (
                                <WidgetContainer
                                    renderChart
                                    chart={dashStore.getChart({
                                        ...chartData[0],
                                        title: newWidget.title,
                                        containerSize: { height: 400, width: 450 },
                                        chartType: newWidget.chartType,
                                        widgetRenderSettings: newWidget.widgetRenderSettings,
                                        kpiType: newWidget.kpiType,
                                    }, chartData[0].data)}
                                    chartKey={newWidget.chartType}
                                    title={newWidget.title}
                                    DynamicDashboardStore={dashStore}
                                    preview
                                    changeTitle={newWidget.newWidgetToWidget()}
                                    key={containerKey}
                                />
                            )
                            : null}
                    </div>
                </div>
            </div>
        </Panel>
    )
}

export default observer(WidgetPreview)
